<template>
  <div
    class="sidebar-logo-container m-rail"
    :class="[collapse ? 'collapse' : 'notitle']"
  >
    <router-link
      class="sidebar-logo-link"
      to="/"
    >
      <img :src="Logo" class="sidebar-logo-img" alt="Logo" />
      <div v-if="!collapse" class="brand-text">
        <span class="brand-name">管理后台</span>
        <span class="brand-sub">ENTERPRISE ERP</span>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import settings from '@/config/default/setting.config'
import Logo from '@/assets/images/logo1.png'
export default defineComponent({
  props: {
    collapse: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const title = settings.title
    return {
      title,
      Logo
    }
  }
})
</script>

<style lang="scss" scoped>
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  background: var(--rail-bg);
  border-bottom: 1px solid var(--line-strong);
  overflow: hidden;

  .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 14px;
    gap: 10px;
    text-decoration: none;

    .sidebar-logo-img {
      width: 28px;
      height: 28px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .brand-text {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      white-space: nowrap;

      .brand-name {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.01em;
        color: var(--ink);
        line-height: 1.2;
      }

      .brand-sub {
        font-size: 9px;
        font-weight: 600;
        letter-spacing: 0.08em;
        color: var(--ink-soft);
        text-transform: uppercase;
        line-height: 1.2;
      }
    }
  }

  &.collapse {
    .sidebar-logo-link {
      justify-content: center;
      padding: 0;
      .sidebar-logo-img {
        margin: 0;
      }
    }
  }
}
</style>
